import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { toast } from "react-toastify";
import CustomSelect from "../../../utils/CustomSelect";
import { Button, Form, Input, Label } from "../../../styles";
import Api from "../../../api/axios";
import MiniLoader from "../../../utils/MIniLoader";
import { useInventoryContext } from "../../../context/inventory_context";
import { useUserContext } from "../../../context/user_context";
import { useItemContext } from "../../../context/item_context";
import { vatType } from "../../../utils/data";


const AddInventory = () => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({});

  const {
    showAddInventory, CloseAddInventory,
    getInventoryData
  } = useInventoryContext();

  const { itemLoading, allItems, getItemData, } = useItemContext();

  const { usertoken, btoken, stoken } = useUserContext();


  function getFn() {
    getItemData();
  }

  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  const item = allItems?.map(({ item, id }) => {
    return (
      { label: item, value: id }
    );
  });

  const vat = vatType?.map(({ name, value }) => {
    return (
      { label: name, value: value }
    );
  });

  function clear() {
    setformField({
      qty: '',
      item_id: '',
      selling_price: '',
      cost_price: '',
      batch_no: '',
      expiry_date: '',
      unit: '',
      qty_limit: '',
      vat_type: '',
    });
  }

  function submitFn(e) {
    e.preventDefault();
    if (
      formField.qty,
      formField.item_id,
      formField.selling_price,
      formField.cost_price
    ) {
      setissending(true);
      const data = {
        usertoken, btoken, stoken,
        qty: formField.qty,
        item_id: formField.item_id,
        selling_price: formField.selling_price,
        cost_price: formField.cost_price,
        batch_no: formField.batch_no,
        expiry_date: formField.expiry_date,
        unit: formField.unit,
        qty_limit: formField.qty_limit,
        vat_type: formField.vat_type,
      };

      Api.post(`/addInventory`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            getInventoryData();
            CloseAddInventory();
          }
        })
        .catch(() => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }

  return (
    <>
      <Modal
        show={showAddInventory}
        onHide={CloseAddInventory}
        backdrop="static"
        keyboard={true}
        onEnter={() => getFn()}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text">
              Create new Inventory
            </h6>
          </Modal.Header>

          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>

              <Label> Item: <span>*</span>
                <MiniLoader
                  load={itemLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={item}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, item_id: e.value }))}
                placeholder='Select Item'
                required
              />
              {/* <p
                className="red-text text-right pointer small"
              onClick={(e) => openAddInventoryCategory()}
              >
                Category not found? Add new
              </p> */}

              <Label> Quantity: <span>*</span></Label>
              <Input
                type="number"
                name="qty"
                placeholder="e.g. 10"
                onChange={handleChange}
                required
                value={formField.qty}
              />

              <Label> Cost Price: <span>*</span></Label>
              <Input
                type="number"
                name="cost_price"
                placeholder="e.g. 1000"
                onChange={handleChange}
                required
                value={formField.cost_price}
              />

              <Label> Selling Price: <span>*</span></Label>
              <Input
                type="number"
                name="selling_price"
                placeholder="e.g. 1000"
                onChange={handleChange}
                required
                value={formField.selling_price}
              />

              <Label> Batch Number:</Label>
              <Input
                type="text"
                name="batch_no"
                placeholder="e.g. BC-100"
                onChange={handleChange}
                value={formField.batch_no}
              />

              <Label> Unit:</Label>
              <Input
                type="number"
                name="unit"
                placeholder="e.g. 10"
                onChange={handleChange}
                value={formField.unit}
              />

              <Label> Quantity Limit:</Label>
              <Input
                type="number"
                name="qty_limit"
                placeholder="e.g. 5"
                onChange={handleChange}
                value={formField.qty_limit}
              />

              <Label> Expiry Date:</Label>
              <Input
                type="date"
                name="expiry_date"
                onChange={handleChange}
                value={formField.expiry_date}
              />

              <Label> VAT Type: <span>*</span>
              </Label>
              <CustomSelect
                options={vat}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, vat_type: e.value }))}
                placeholder='Select VAT Type'
                required
              />



              <div className="col-md-10 mx-auto text-center mb-4">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      {/* Add Inventory Modal */}

      {/* <AddInventoryCategory
      /> */}
      {/* Add Inventory Modal */}
    </>
  );
};

export default AddInventory;
